import { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { LoginForm } from "@/features/auth/components/LoginForm";
import { useAuth } from "@/shared/hooks/useAuth";
import riLogo from "@/shared/assets/ri_logo.png";

export default function Login() {
  const { user, loading, signOut } = useAuth();
  const isAuthenticated = user !== null;
  const hasCheckedInitialSession = useRef(false);

  useEffect(() => {
    // Wait until Firebase has initialized its initial state
    if (loading) return;

    // We only want to check their incoming session state one single time when the component becomes ready
    if (!hasCheckedInitialSession.current) {
      hasCheckedInitialSession.current = true;

      // If they were ALREADY authenticated upon arriving at the login page, clear it
      if (isAuthenticated) {
        signOut();
      }
    }
  }, [isAuthenticated, loading, signOut]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-muted-foreground">Loading...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background p-4">
      <div className="w-full max-w-md space-y-6">
        <Link to="/" className="flex items-center justify-center gap-3">
          <img
            src={riLogo}
            alt="Robotic Imaging logo"
            className="h-10 w-10 shrink-0 rounded-lg object-contain"
            decoding="async"
          />
          <div>
            <span className="text-xl font-bold text-foreground tracking-wide">ROBOTIC IMAGING</span>
            <div className="text-xs text-primary font-medium">ASSET MANAGEMENT</div>
          </div>
        </Link>

        <div className="bg-card border border-border rounded-lg p-6 shadow-sm">
          <h1 className="text-foreground text-xl font-semibold mb-4">Sign In</h1>
          <LoginForm variant="fullscreen" />
        </div>
      </div>
    </div>
  );
}
